module.exports = __webpack_public_path__ + "static/media/subcontractor.e323bfa3.svg";